import React from "react";
import { Link, Redirect } from "react-router-dom";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import appleStores from "images/stores/apple-store.svg";
import googlePlay from "images/stores/google-play.svg";

import { useIsMobile } from "app/hooks";
import styles from "./not-found.module.scss";

const NotMobileAppInstalled: React.FC = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        <div className={styles.container}>
          <h1>
            <Trans>Uh oh!</Trans>
          </h1>
          <hr />
          <p>
            <Trans>
              Download the CultureHQ app to be able to share
              your story on the Social Network
            </Trans>
            <br /><br />
          </p>
        </div>
        <div className="col-xs-12 Login__Links">
          <a href="https://play.google.com/store/apps/details?id=com.culturehq.mobile" target="_blank" rel="noopener noreferrer">
            <img className="Login__Links--Icon Login__Links--Icon__google" src={googlePlay} alt="Google play link" />
          </a>
          <a href="https://apps.apple.com/us/app/culturehq/id1549635532" target="_blank" rel="noopener noreferrer">
            <img className="Login__Links--Icon" src={appleStores} alt="Apple store link" />
          </a>
        </div>
      </>
    );
  }
  return <Redirect to="/403" />;
};

export default NotMobileAppInstalled;
